"use client";

import { Menu, Bell, Search } from "lucide-react";

interface MobileHeaderProps {
  onMenuClick: () => void;
  title: string;
  showSearch?: boolean;
}

export function MobileHeader({ onMenuClick, title, showSearch = false }: MobileHeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-200 z-40 md:hidden">
      <div className="flex items-center justify-between h-full px-4">
        {/* Left: Menu Button */}
        <button
          onClick={onMenuClick}
          className="w-10 h-10 flex items-center justify-center text-gray-700 -ml-2"
        >
          <Menu className="w-6 h-6" />
        </button>

        {/* Center: Title */}
        <h1 className="text-lg font-bold text-gray-900 truncate flex-1 mx-3">
          {title}
        </h1>

        {/* Right: Actions */}
        <div className="flex items-center gap-1">
          {showSearch && (
            <button className="w-10 h-10 flex items-center justify-center text-gray-700">
              <Search className="w-5 h-5" />
            </button>
          )}
          <button className="w-10 h-10 flex items-center justify-center text-gray-700 relative">
            <Bell className="w-5 h-5" />
            <span className="absolute top-2 right-2 w-2 h-2 bg-red-600 rounded-full"></span>
          </button>
        </div>
      </div>
    </header>
  );
}
